import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosPsychometricEvaluationModalComponent } from './pos-psychometric-evaluation-modal.component';
import { PosQrCodeModule } from '../pos-qr-code/pos-qr-code.module';
import { ModalModule } from 'ngx-bootstrap/modal';



@NgModule({
  declarations: [PosPsychometricEvaluationModalComponent],
  imports: [
    CommonModule,
    PosQrCodeModule,
    ModalModule.forRoot()
  ],
  exports: [PosPsychometricEvaluationModalComponent]
})
export class PosPsychometricEvaluationModalModule { }
